
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { CrayonProductModel } from 'models/generated/Distribution.Api.Models.Csp.CrayonProduct';


const _distribution_ProductControllerHelper = new Map<string, Object>();
_distribution_ProductControllerHelper.set('GetProducts', CrayonProductModel);
_distribution_ProductControllerHelper.set('RefreshCrayonProducts', CrayonProductModel);


export const distribution_ProductControllerHelper = _distribution_ProductControllerHelper;

